import React, { useState, useEffect } from 'react';
import KPIHeader from '../../Header/KPIHeader';
import KPISubHeader from '../../Header/SubHeader/KPISubHeader';
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";

import StateWiseStatistics from '../../KPI/Project Level/StateWiseStatistics';
import StatusSummaryChart from '../../KPI/Project Level/StatusSummaryChart';
import WaterfallChartComponent from '../../KPI/Project Level/WaterfallChartComponent';
import FunnelChartComponent from '../../KPI/Project Level/FunnelChart';
import FunnelViewChart from '../../KPI/Project Level/FunnelViewChart';
import AttributesDashboard from '../../KPI/Project Level/AttributesDashboard';
import ProjectLevelDefitions from '../../Defintions/ProjectLevelDefitions';

import { getSession } from "../../utils/session";
import { setProjectDetails } from "../../userSlice";
import EnterpriseMsmeTable from '../../KPI/enterprise/EnterpriseMsmeTable';

const Projectlevel = () => {

  const dispatch = useDispatch();

  // ✅ Redux values
  const reduxProjectName = useSelector((state) => state.user.projectName);
  const reduxPid = useSelector((state) => state.user.projectId);
  const reduxEmail = useSelector((state) => state.user.email);
  const reduxRoleId = useSelector((state) => state.user.roleId);

  // ✅ Local state
  const [projectName, setProjectName] = useState(reduxProjectName);
  const [pid, setPid] = useState(reduxPid);
  const [email, setEmail] = useState(reduxEmail);
  const [roleId, setRoleId] = useState(reduxRoleId);

  // ✅ Loading state to prevent premature redirect
  const [loading, setLoading] = useState(true);

  // ✅ SESSION RESTORE (FIXED)
  useEffect(() => {
    const session = getSession();

    if (session?.email) {
      setProjectName(session.projectName);
      setPid(session.projectId);
      setEmail(session.email);
      setRoleId(session.roleId);

      // ✅ Sync Redux
      dispatch(setProjectDetails({
        email: session.email,
        projectName: session.projectName,
        projectId: session.projectId,
        organizationName: session.organizationName,
        roleId: session.roleId
      }));
    }

    setLoading(false); // ✅ Important
  }, [dispatch]);

  // ✅ Prevent flicker / wrong redirect
  if (loading) return null;

  // ❌ Redirect if no session/email
  if (!email) {
    return <Navigate to="/" replace />;
  }

  const handleRedirect = () => {
    window.open('https://dfl-insights.haqdarshak.com/', '_blank');
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      <KPIHeader />
      <KPISubHeader />

      <div className="mt-24">

        {/* ✅ HEADER */}
        <div className="px-6 py-2 flex items-center justify-between border-b border-gray-200 bg-white rounded-lg shadow-sm">
          <div className="flex items-center space-x-4">
            <div className="bg-blue-100 p-2 rounded-lg">
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4z" />
              </svg>
            </div>

            <h1 className="text-2xl font-bold text-gray-800 truncate">
              {projectName}
            </h1>
          </div>

          <span><ProjectLevelDefitions /></span>

          <span className="bg-gradient-to-r from-purple-100 to-indigo-100 text-purple-800 text-sm font-semibold px-4 py-2 rounded-full">
            PID: {pid}
          </span>
        </div>

        {/* ✅ CHARTS */}
        <div className="bg-gray-50 p-6">
          <WaterfallChartComponent />
          <FunnelChartComponent />

          {/* ✅ ROLE BASED CONTROL */}
          {roleId !== 28 && <FunnelViewChart />}
        </div>

        {/* ✅ BUTTON */}
        <button
          onClick={handleRedirect}
          className="group ml-[30vw] mb-4 px-6 py-3 rounded-full text-white bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700"
        >
          Click here to see DFL Camps Dashboard
        </button>

        {/* ✅ OTHER COMPONENTS */}
        <StateWiseStatistics />
        <StatusSummaryChart />
        <AttributesDashboard />
       {roleId !== 28 && <EnterpriseMsmeTable/>}

      </div>
    </div>
  );
};

export default Projectlevel;